import { convertStringToInteger } from 'common/helpers/numberHelper';

export const imageFile = (image, newSize) => {
  const allowedSizes = ['small', 'medium', 'large', 'x-large'];
  if (!allowedSizes.includes(newSize)) {
    throw new Error('Invalid Image Size');
  }
  return image.replace('original', newSize);
};

export const removeSpaces = (string) => {
  let newString = string;
  newString = newString.replace(/ /g, '');
  return newString;
};

export const cartHasGiftCards = (cart) => {
  let hasGiftCards = false;
  const giftCard = cart.tenders.find(
    (tender) =>
      tender.tenderType === 'Gift Card' &&
      tender.amountTendered > 0 &&
      tender.chargeStatus !== 'Failed'
  );
  if (giftCard) {
    hasGiftCards = true;
  }
  return hasGiftCards;
};

export const pad = (padString, str) => {
  if (typeof str === 'undefined') {
    return padString;
  }
  return (padString + str).slice(-padString.length);
};

export const getCartTitle = (settings, t) => {
  if (settings.defaultCountryCode === 'GB') {
    return 'Basket';
  }
  return t('checkout.general.cart');
};

export const transformBirthdayValues = (values) => {
  const data = {};
  data.birthDay = values?.birthDay && convertStringToInteger(values.birthDay);
  data.birthMonth =
    values?.birthMonth && convertStringToInteger(values.birthMonth);
  data.birthYear =
    values?.birthYear && convertStringToInteger(values.birthYear);
  return data;
};
